<template>
  <section class="primaryInfo">
    <a
      name="home"
      style="
        position: relative;
        top: -420px;
        display: block;
        height: 0;
        overflow: hidden;
      "
    ></a>
    <section class="information">
      <section class="innerBox">
        <div class="info">
          <!-- <h1>About Us</h1> -->
          <NavCrumbs :crumbProp="crumbProp" v-show="isPc"></NavCrumbs>

          <img
            src="../assets/img/AboutUs.jpeg"
            alt="ToTok is a secure and free video calling app developed by a group of international entrepreneurs"
            style="display: block; margin: 20px auto; max-width: 100%;"
          />
          <p>
            ToTok is a private mobile internet company with offices in Abu Dhabi
            and Singapore.
          </p>
          <p>
            ‪We are a group of international entrepreneurs from some of the most
            recognized companies in the world, with a common goal of building
            the next-generation, communication-based digital platform.
          </p>
          <p>
            Attracted by the high-growth potential and vibrant digital ecosystem
            of the MENA region, we set up an office in Abu Dhabi, UAE, in 2019.
            Thanks to its extraordinary call quality and user experience, ToTok
            quickly became the most popular app in the region.
          </p>
          <p>
            Down the road, we are going to introduce more exciting
            functionalities that will further enhance the mobile experience of
            our users.
          </p>
          <p>
            ‪Our people are our greatest asset, and we strive to attract talent
            from the broadest pool to foster innovation, creativity and
            productivity. There is tremendous power that results from this kind
            of diversity. We are deeply committed to hiring and retaining
            employees from different backgrounds, experiences and locations.
          </p>
          <p>
            Join the ToTok family and share our spirit of entrepreneurship at
            one of our offices. Let’s connect!
          </p>
          <p style="margin-bottom: 40px;">
            <a href="mailto:job@totok.ai">job@totok.ai</a>
          </p>
        </div>
        <!-- <div class="cp">All rights reserved, 2020 © Totok Pte. Ltd.</div> -->
      </section>
    </section>
    <Footer></Footer>
  </section>
</template>

<script>
import NavCrumbs from "@/components/NavCrumbs.vue";
import NewsBar from "@/components/NewsBar.vue";
import Footer from "@/components/Footer.vue";
export default {
  metaInfo() {
    return {
      title: "About Us",
      // meta: [{
      //     vmid: 'og:title',
      //     property: 'og:title',
      //     name: 'og:title',
      //     content: 'Terms of Use - ToTok Messenger',
      // },{
      //     vmid:"og:description",
      //     property: 'og:description',
      //     name: 'og:description',
      //     content: 'Enjoy FREE, FAST and FUN calling with your family and friends.'
      // },]
      meta: [
        { property: "og:title", content: "About Us" },
        { property: "og:description", content: "About Us" },
        { property: "og:url", content: "https://totok.ai/aboutus" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: "https://static.totok.ai/pic/preview/free_unblocked_call.png",
        },
        { property: "og:site_name", content: "ToTok" },
      ],
    };
  },
  components: {
    NewsBar,
    NavCrumbs,
    Footer,
  },
  data() {
    return {
      crumbProp: {
        label: "About Us",
        type: "simple",
      },
      showinfo: false,
      isActive: "Jan05",
      leftMenus: [
        {
          title: "Jan 05",
          anchorId: "Jan05",
        },
        {
          title: "Dec 29",
          anchorId: "Dec29",
        },
        {
          title: "Dec 27",
          anchorId: "Dec27",
        },
        {
          title: "Dec 24",
          anchorId: "Dec24",
        },
        {
          title: "Dec 23",
          anchorId: "Dec23",
        },
      ],
    };
  },
  computed: {
    info() {
      return [];
    },
    isPc() {
      return document.body.offsetWidth > 450;
    },
    isIOS() {
      return navigator.userAgent.toLowerCase().indexOf("iphone") >= 0;
    },
  },
  methods: {
    gotoHandle(palice) {
      console.log("palice", palice);
      switch (palice) {
        case "Jan05":
          this.isActive = "Jan05";
          this.$router.push({ name: "newsJan05" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec29":
          this.isActive = "Dec29";
          this.$router.push({ name: "newsDec29" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec27":
          this.isActive = "Dec27";
          this.$router.push({ name: "newsDec27" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec24":
          this.isActive = "Dec24";
          this.$router.push({ name: "newsDec24" });
          // this.mainPannel.scrollTo(0, 2000)
          break;
        case "Dec23":
          this.isActive = "Dec23";
          // this.$router.push({name:'newsDec22'})
          // this.mainPannel.scrollTo(0, 0)
          this.$router.push({ name: "newsDec22" });
          break;
      }
    },
  },
};
</script>
<style scoped lang="stylus">
@media only screen and (max-width: 700px) {
    .primaryInfo {

        // background: #fff;
        height: auto;
        .innerBox {
            padding-bottom: 50px;
        }
        .leftMenu {
            display none
        }

        div {
            margin-left: 20px;
            margin-right: 20px;
        }

        .info {


            h1 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 40px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 3.5rem;
        font-size: 13px;
        color: #808080;
        line-height: 3.5rem;
        text-align: center;
    }
}

@media only screen and (min-width: 701px) {
    .primaryInfo {
        padding-top: 86px;
        width: 100vw;
        background: #fff;

        .information {
            margin: 0 auto;
            width: 800px;

            .innerBox {
                position relative;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                width:800px;
                min-height: 83vh;
                overflow: auto;


                .leftMenu {
                    position: absolute;
                    left: 0px;
                    top: 39px;
                    display flex;
                    flex-direction column;
                    justify-content center;
                    align-items: flex-start;
                    list-style none;

                    .menu-item {
                        color: #979797;
                        margin-top: 30px;
                        cursor pointer;
                        text-decoration none;
                        font-size: 15px;
                        letter-spacing: 1px;
                    }

                    .menu-item:nth-child(1) {
                        margin-top: 0px;
                    }

                    .menu-item--active {
                        color: #000;
                        border-bottom: 2px solid #4377f2;
                    }

                }
            }
        }

        .info {
            width: 800px;
            margin: 20px 0;
margin-bottom:60px;
            h1 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 28px;
                font-weight: 400;
                color: #222222;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 20px;
                padding-top: 20px;
                margin: 0px;
                line-height: 40px;
            }

            h2 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 24px;
                font-weight: 400;
                color: #4377f2;
                -webkit-font-smoothing: antialiased;
                padding-bottom: 18px;
                padding-top: 28px;
                margin: 0px;
            }

            h3 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: 400;
                color: #808080;
                padding-bottom: 20px;
                margin: 0;
            }

            h6 {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-style: italic;
                font-size: 16px;
                font-weight: bold;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            p {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            ul {
                list-style: disc;
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0;
                margin-bottom: 10px;
                margin-left: 24px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }

            li {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-top: 0px;
                margin-bottom: 10px;
                color: #555555;
                text-rendering: optimizeLegibility;
                line-height: 26px;
                margin-left: 20px;
            }

            a {
                font-family: "sofiapro-regular","Calibri Light","Helvetica Neue" , Roboto, sans-serif;
                font-size: 16px;
                font-weight: normal;
                margin-bottom: 12px;
                color: #4377f2;
                text-rendering: optimizeLegibility;
                line-height: 26px;
            }
        }
    }

    .cp {
        height: 70px;
        font-size: 13px;
        color: #808080;
        line-height: 70px;
        text-align: center;
    }
}
</style>
